<template>
  <div ref="chartWrapper"
       class="widget-wrapper portlet-traffic-block"
  >
    <div class="row">

      <div class="col-xs-3 col-sm-3 col-md-3">
        <!-- 유입 트래픽 시작 -->
        <div class="traffic-state-group traffic-state-group-left">

          <div class="traffic-state">
            <p class="traffic-title">{{ $t('dash.widgetFwSummary_title_inflowTraffic') }}</p>
            <p class="traffic-value">{{ inflowTraffic }}/h</p>
          </div>

          <div class="traffic-arrow-group">
            <div class="traffic-arrow-ani arrow-ani-01">
              <svg version="1.1" class="traffic-arrow" x="0px" y="0px" width="28px" height="50px" viewBox="0 0 28 50" enable-background="new 0 0 28 50" xml:space="preserve">
                                  <path fill="#428de1" d="M27.584,23.909L1.334,0.191C1.063-0.052,0.725-0.064,0.449,0.163C0.172,0.389,0,0.817,0,1.282v47.436
                                    c0,0.465,0.172,0.893,0.449,1.12C0.581,49.946,0.728,50,0.875,50c0.159,0,0.318-0.064,0.459-0.191l26.25-23.718
                                    C27.843,25.858,28,25.445,28,25S27.843,24.142,27.584,23.909z"/>
                                </svg>
            </div>
            <div class="traffic-arrow-ani arrow-ani-02">
              <svg version="1.1" class="traffic-arrow" x="0px" y="0px" width="28px" height="50px" viewBox="0 0 28 50" enable-background="new 0 0 28 50" xml:space="preserve">
                                  <path fill="#8abaf0" d="M27.584,23.909L1.334,0.191C1.063-0.052,0.725-0.064,0.449,0.163C0.172,0.389,0,0.817,0,1.282v47.436
                                    c0,0.465,0.172,0.893,0.449,1.12C0.581,49.946,0.728,50,0.875,50c0.159,0,0.318-0.064,0.459-0.191l26.25-23.718
                                    C27.843,25.858,28,25.445,28,25S27.843,24.142,27.584,23.909z"/>
                                </svg>
            </div>
            <div class="traffic-arrow-ani arrow-ani-03">
              <svg version="1.1" class="traffic-arrow" x="0px" y="0px" width="28px" height="50px" viewBox="0 0 28 50" enable-background="new 0 0 28 50" xml:space="preserve">
                                  <path fill="#ffffff" d="M27.584,23.909L1.334,0.191C1.063-0.052,0.725-0.064,0.449,0.163C0.172,0.389,0,0.817,0,1.282v47.436
                                    c0,0.465,0.172,0.893,0.449,1.12C0.581,49.946,0.728,50,0.875,50c0.159,0,0.318-0.064,0.459-0.191l26.25-23.718
                                    C27.843,25.858,28,25.445,28,25S27.843,24.142,27.584,23.909z"/>
                                </svg>
            </div>
          </div>

        </div>
        <!-- 유입 트래픽 끝 -->
      </div>

      <div class="col-xs-6 col-sm-6 col-md-6" style="padding: 0 30px;">
        <!-- 트래픽 유형 시작 -->
        <div class="contents-row traffic-type-wrapper">

          <!-- 적응형 (필독!! : row > bs-row-divide, col-xs, col-sm, col-md 한셋트로 구조를 맞춰야함 ) 시작 -->
          <div class="row">

            <!-- 유형 - 방화벽 차단 시작 -->
            <div class="col-xs-6 col-sm-6 col-md-6">
              <div class="traffic-type-group">
                <div class="traffic-type-icon-list-top">
                  <p class="traffic-type-icon-list-title">{{ $t('dash.widgetFwSummary_title_fwBlocking') }}</p>
                </div>
                <div class="traffic-type-icon">
                  <svg version="1.1" class="traffic-type-svg" viewBox="0 0 65.745 80" enable-background="new 0 0 65.745 80" xml:space="preserve">
                                      <g>
                                        <path fill="#4ce0ed" d="M64.461,10.619L33.556,0.09c-0.388-0.129-0.803-0.131-1.188,0L1.286,10.576C0.518,10.833,0,11.563,0,12.383
                                          v20.12C0,57.97,4.226,67.271,32.2,79.83c0.243,0.109,0.501,0.163,0.76,0.163s0.518-0.054,0.761-0.163
                                          C61.694,67.271,65.745,57.97,65.745,32.503V12.426C65.745,11.607,65.229,10.879,64.461,10.619z M49.759,51.546
                                          c0,1.963-1.592,3.555-3.555,3.555H19.542c-1.963,0-3.555-1.592-3.555-3.555V28.438c0-1.963,1.592-3.555,3.555-3.555h26.662
                                          c1.963,0,3.555,1.592,3.555,3.555V51.546z"/>
                                        <path fill="#4ce0ed" d="M32.873,32.76c-2.098,0-3.798,1.701-3.798,3.801c0,1.617,1.014,2.989,2.438,3.538l-1.305,7.126h5.332
                                          l-1.194-7.161c1.366-0.575,2.326-1.926,2.326-3.502C36.671,34.461,34.97,32.76,32.873,32.76z"/>
                                      </g>
                                    </svg>
                </div>
                <div class="traffic-type-icon-list">
                  <p class="traffic-type-icon-list-value">{{ fwBlockBytes }}/h</p>
                </div>
              </div>
            </div>
            <!-- 유형 - 방화벽 차단 끝 -->

            <!-- 유형 - 보안 시작 -->
            <div class="col-xs-6 col-sm-6 col-md-6">
              <div class="traffic-type-group">
                <div class="traffic-type-icon-list-top">
                  <p class="traffic-type-icon-list-title">{{ $t('dash.widgetFwSummary_title_securityEvent') }}</p>
                </div>
                <div class="traffic-type-icon">
                  <svg version="1.1" class="traffic-type-svg" viewBox="0 0 59.303 80" enable-background="new 0 0 59.303 80" xml:space="preserve">
                                      <path fill="#4ce0ed" d="M53.409,29.497v-6.031C53.409,10.176,43.452,0,30.161,0C16.871,0,5.802,10.176,5.802,23.465v6.031H0V77.36
                                        C0,78.818,1.181,80,2.64,80h54.023c1.459,0,2.64-1.182,2.64-2.64V29.497H53.409z M33.653,68.21h-7.901l1.386-12.365
                                        c-1.982-0.958-3.359-2.969-3.359-5.317c0-3.273,2.653-5.926,5.927-5.926c3.271,0,5.924,2.653,5.924,5.926
                                        c0,2.348-1.379,4.359-3.359,5.317L33.653,68.21z M11.744,29.497v-6.031c0-10.163,8.255-17.795,18.417-17.795
                                        c10.163,0,17.307,7.632,17.307,17.795v6.031H11.744z"/>
                                    </svg>
                </div>
                <div class="traffic-type-icon-list">
                  <p class="traffic-type-icon-list-value">{{ securityCnt }}/h</p>
                </div>
              </div>
            </div>
            <!-- 유형 - 보안 끝 -->

            <!-- 유형 - 위협 시작 -->
            <!-- <div class="col-xs-6 col-sm-6 col-md-6">
              <div class="traffic-type-group">
                <div class="traffic-type-icon-list-top">
                  <p class="traffic-type-icon-list-title">위협</p>
                </div>
                <div class="traffic-type-icon">
                  <svg version="1.1" class="traffic-type-svg" viewBox="0 0 93.995 80" enable-background="new 0 0 93.995 80" xml:space="preserve">
                    <path fill="#4ce0ed" d="M93.307,70.943C83.347,51.9,62.902,20.382,52.943,3.437C51.764,1.435,49.596,0,46.996,0
                      c-2.6,0-4.77,1.435-5.946,3.436C31.09,20.381,10.647,51.9,0.689,70.943C0.255,71.772,0,72.696,0,73.682C0,77.171,3.008,80,6.717,80
                      l40.28-0.004L87.278,80c3.708,0,6.717-2.828,6.717-6.317C93.995,72.696,93.741,71.772,93.307,70.943z M47,46.727
                      c2.762,0,5,2.278,5,5.087c0,2.808-2.238,5.083-5,5.083c-2.761,0-5-2.275-5-5.083C42,49.005,44.239,46.727,47,46.727z M26.095,51.041
                      c0-8.137,4.495-14.424,11.094-17.999l5.625,10.761c-2.827,1.534-4.773,4.128-4.773,7.613c0,0.109,0.247,0.654,0.25,0.762h-12.19
                      C26.092,51.929,26.095,51.291,26.095,51.041z M47,73.077c-4.071,0-7.857-1.203-11.069-3.251l5.842-10.689
                      c1.377,0.877,3.482,1.789,5.228,1.789s3.844-0.912,5.221-1.789l5.848,10.689C54.857,71.874,51.071,73.077,47,73.077z M67.895,52.177
                      h-12.19c0.004-0.107,0.254-0.652,0.254-0.762c0-3.485-1.945-6.079-4.771-7.613l5.623-10.761c6.599,3.575,11.096,9.862,11.096,17.999
                      C67.907,51.291,67.903,51.929,67.895,52.177z"/>
                  </svg>
                </div>
                <div class="traffic-type-icon-list">
                  <p class="traffic-type-icon-list-title">위협</p>
                  <p class="traffic-type-icon-list-value">480</p>
                </div>
              </div>
            </div> -->
            <!-- 유형 - 위협 끝 -->

            <!-- 유형 - 데이타 필터 시작 -->
            <!-- <div class="col-xs-6 col-sm-6 col-md-6">
              <div class="traffic-type-group">
                <div class="traffic-type-icon-list-top">
                  <p class="traffic-type-icon-list-title">데이타 필터</p>
                </div>
                <div class="traffic-type-icon">
                  <svg version="1.1" class="traffic-type-svg" viewBox="0 0 98.818 80" enable-background="new 0 0 98.818 80" xml:space="preserve">
                    <path fill="#4ce0ed" d="M90.461,0H8.354C0.398,0,0,0.405,0,8.497v63.004C0,79.593,0.398,80,8.354,80h1.053V63.537h14.111V80h7.056
                      V56.481h14.112V80h7.056V68.241h14.111V80h7.056V51.777h14.111V80h3.44c7.956,0,8.356-0.406,8.356-8.498V8.497
                      C98.818,0.405,98.417,0,90.461,0z M66.529,12.763L52.941,28.257v18.815l-7.056-7.056v-11.76l-13.7-15.494
                      c-1.008-1.463-0.084-3.339,1.717-3.339h30.909C66.634,9.384,67.765,11.467,66.529,12.763z"/>
                  </svg>
                </div>
                <div class="traffic-type-icon-list">
                  <p class="traffic-type-icon-list-title">데이타 필터</p>
                  <p class="traffic-type-icon-list-value">480</p>
                </div>
              </div>
            </div> -->
            <!-- 유형 - 데이타 필터 끝 -->

            <!-- 유형 - 웹 필터 시작 -->
            <!-- <div class="col-xs-6 col-sm-6 col-md-6">
              <div class="traffic-type-group">
                <div class="traffic-type-icon-list-top">
                  <p class="traffic-type-icon-list-title">웹 필터</p>
                </div>
                <div class="traffic-type-icon">
                  <svg version="1.1" class="traffic-type-svg" viewBox="0 0 112.889 80" enable-background="new 0 0 112.889 80" xml:space="preserve">
                    <g>
                      <g>
                        <path fill="#4ce0ed" d="M0,72.932C0,75.533,3.88,80,6.141,80h100.605c2.262,0,6.143-4.467,6.143-7.068H0z"/>
                      </g>
                    </g>
                    <path fill="#4ce0ed" d="M101.151,0H11.738C9.14,0,7.033,2.107,7.033,4.706v61.177h98.825V4.706C105.857,2.107,103.75,0,101.151,0z
                       M73.566,17.449L59.973,32.95v18.823l-7.058-7.059V32.95L39.208,17.449c-1.009-1.463-0.084-3.341,1.718-3.341h30.921
                      C73.672,14.068,74.803,16.152,73.566,17.449z"/>
                  </svg>
                </div>
                <div class="traffic-type-icon-list">
                  <p class="traffic-type-icon-list-title">웹 필터</p>
                  <p class="traffic-type-icon-list-value">480</p>
                </div>
              </div>
            </div> -->
            <!-- 유형 - 웹 필터 끝 -->

            <!-- 유형 - 안티 스팸 시작 -->
            <!-- <div class="col-xs-6 col-sm-6 col-md-6">
              <div class="traffic-type-group">
                <div class="traffic-type-icon-list-top">
                  <p class="traffic-type-icon-list-title">안티 스팸</p>
                </div>
                <div class="traffic-type-icon">
                  <svg version="1.1" class="traffic-type-svg" viewBox="0 0 88.657 80" enable-background="new 0 0 88.657 80" xml:space="preserve">
                    <g>
                      <polygon fill="#69CBDD" points="12.905,24.519 3.663,28.218 12.905,35.614 	"/>
                      <polygon fill="#69CBDD" points="75.752,24.519 75.752,35.614 84.994,28.218 	"/>
                      <path fill="#4ce0ed" d="M84.962,34.601L62.489,50.294c0.129,0.876,0.218,1.767,0.218,2.679c0,10.15-8.229,18.379-18.378,18.379
                        c-3.719,0-7.175-1.113-10.067-3.014L59.679,42.92c0.518,0.79,0.989,1.615,1.383,2.483l10.293-6.484V0H17.302v38.919l10.289,6.493
                        c2.884-6.375,9.286-10.817,16.738-10.817c4.26,0,8.147,1.486,11.259,3.921L29.845,64.259c-2.432-3.116-3.895-7.027-3.895-11.286
                        c0-0.912,0.089-1.803,0.218-2.679L3.694,34.601C1.653,34.601,0,36.294,0,38.385v37.831C0,78.307,1.653,80,3.694,80h81.268
                        c2.04,0,3.695-1.693,3.695-3.784V38.385C88.657,36.294,87.002,34.601,84.962,34.601z"/>
                    </g>
                  </svg>
                </div>
                <div class="traffic-type-icon-list">
                  <p class="traffic-type-icon-list-title">안티 스팸</p>
                  <p class="traffic-type-icon-list-value">480</p>
                </div>
              </div>
            </div> -->
            <!-- 유형 - 안티 스팸 끝 -->

          </div>
          <!-- 적응형 (필독!! : row > bs-row-divide, col-xs, col-sm, col-md 한셋트로 구조를 맞춰야함 ) 끝 -->

        </div>
        <!-- 트래픽 유형 끝 -->
      </div>

      <div class="col-xs-3 col-sm-3 col-md-3">
        <!-- 유출 트래픽 시작 -->
        <div class="traffic-state-group traffic-state-group-right">

          <div class="traffic-arrow-group">
            <div class="traffic-arrow-ani arrow-ani-01">
              <svg version="1.1" class="traffic-arrow" x="0px" y="0px" width="28px" height="50px" viewBox="0 0 28 50" enable-background="new 0 0 28 50" xml:space="preserve">
                                  <path fill="#ffffff" d="M27.584,23.909L1.334,0.191C1.063-0.052,0.725-0.064,0.449,0.163C0.172,0.389,0,0.817,0,1.282v47.436
                                    c0,0.465,0.172,0.893,0.449,1.12C0.581,49.946,0.728,50,0.875,50c0.159,0,0.318-0.064,0.459-0.191l26.25-23.718
                                    C27.843,25.858,28,25.445,28,25S27.843,24.142,27.584,23.909z"/>
                                </svg>
            </div>
            <div class="traffic-arrow-ani arrow-ani-02">
              <svg version="1.1" class="traffic-arrow" x="0px" y="0px" width="28px" height="50px" viewBox="0 0 28 50" enable-background="new 0 0 28 50" xml:space="preserve">
                                  <path fill="#8abaf0" d="M27.584,23.909L1.334,0.191C1.063-0.052,0.725-0.064,0.449,0.163C0.172,0.389,0,0.817,0,1.282v47.436
                                    c0,0.465,0.172,0.893,0.449,1.12C0.581,49.946,0.728,50,0.875,50c0.159,0,0.318-0.064,0.459-0.191l26.25-23.718
                                    C27.843,25.858,28,25.445,28,25S27.843,24.142,27.584,23.909z"/>
                                </svg>
            </div>
            <div class="traffic-arrow-ani arrow-ani-03">
              <svg version="1.1" class="traffic-arrow" x="0px" y="0px" width="28px" height="50px" viewBox="0 0 28 50" enable-background="new 0 0 28 50" xml:space="preserve">
                                  <path fill="#428de1" d="M27.584,23.909L1.334,0.191C1.063-0.052,0.725-0.064,0.449,0.163C0.172,0.389,0,0.817,0,1.282v47.436
                                    c0,0.465,0.172,0.893,0.449,1.12C0.581,49.946,0.728,50,0.875,50c0.159,0,0.318-0.064,0.459-0.191l26.25-23.718
                                    C27.843,25.858,28,25.445,28,25S27.843,24.142,27.584,23.909z"/>
                                </svg>
            </div>
          </div>

          <div class="traffic-state">
            <p class="traffic-title">{{ $t('dash.widgetFwSummary_title_outflowTraffic') }}</p>
            <p class="traffic-value">{{ outflowTraffic }}/h</p>
          </div>

        </div>
        <!-- 유출 트래픽 끝 -->
      </div>
    </div>
  </div>
</template>
<script>
  // 위젯 Mixin 객체
  import {widgetMixin} from '~/mixins/widgetCommonMixin'

  // 스토어 헬퍼
  import {createNamespacedHelpers} from 'vuex'

  // 스토어 헬퍼 객체
  const {mapGetters} = createNamespacedHelpers('common/common/')
  const {mapActions} = createNamespacedHelpers('dashboard/dashboard')

  export default {
    name: 'widgetFwSummary',
    components: {},
    directives: {},
    mixins: [widgetMixin],
    data () {
      return {
        w: 2,
        opts: {
          unit: 'bps'
        },
        title: 'widgetFwSummary',
        isLock: false,
        isMove: true,
        isResize: false,
        eventBus: true,
        isMaximum: false,
        widgetData: {
          result: [],
          unit_time: ''
        }
      }
    },
    computed: {
      ...mapGetters([
        'getDeviceTime'
      ]),
      getResultData () {
        // 위젯 데이터가 있는 경우
        if (this.widgetData.result.length > 0) {
          return this.widgetData.result[0]
        } else {
          return {}
        }
      },
      threatCnt () {
        return this.separateByComma(this.getResultData.threat_cnt || 0)
      },
      antiSpamCnt () {
        return this.separateByComma(this.getResultData.anti_spam_cnt || 0)
      },
      fwBlockBytes () {
        return this.byteConverter(this.getResultData.deny_bytes || 0)
      },
      securityCnt () {
        return this.separateByComma(this.getResultData.security_cnt || 0)
      },
      webFilterCnt () {
        return this.separateByComma(this.getResultData.web_filter_cnt || 0)
      },
      dataFilterCnt () {
        return this.separateByComma(this.getResultData.data_filter_cnt || 0)
      },
      inflowTraffic () {
        return this.byteConverter(this.getResultData.in_bytes || 0)
      },
      outflowTraffic () {
        return this.byteConverter(this.getResultData.pass_bytes || 0)
      }
    },
    beforeCreate () {},
    created () {},
    beforeMount () {},
    mounted () {},
    beforeUpdate () {},
    updated () {},
    activated () {},
    deactivated () {},
    beforeDestroy () {},
    destroyed () {},
    errorCaptured () {},
    methods: {
      ...mapActions([
        'getWidgetData'
      ]),
      async getWidgetContentsData (init = false) {
        // Progress 출력 여부
        this.showProgress(true)

        // initFlag가 True면 기존 차트 데이터 초기
        if (init) {
          this.widgetData = {
            result: [],
            unit_time: ''
          }
        }

        const contentsOptions = {
          widgetType: 'firewall_summary'
        }

        // API 호출
        const {code, result} = await this.getWidgetData(contentsOptions)

        // 방화벽 요약 데이터 맵핑
        if (code === 'ok') {
          this.widgetData = result
        }

        // Progress 출력 여부
        this.showProgress(false)
      }
    },
    watch: {}
  }
</script>
<style scoped>
  .widget-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
  }

  .widget-contents {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }
</style>
